'use client';
import About from '@/components/about/page';
import Hero from '@/components/hero/page';
import HowItWorks from '@/components/how-it-works/page';
// import Pricing from '@/components/pricing/page';
// import Testimonial from '@/components/testimonial/page';

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <HowItWorks />
      {/* <Pricing />
      <Testimonial /> */}
    </>
  );
}
